module.exports = __webpack_public_path__ + "img/دکمه-ایی.2d50eecc.png";